import * as actions from './constants';
import { initialState } from './initialState';

export default function (state = initialState, action) {
  switch (action.type) {
    case actions.SET_CONFIRM_SMS_CODE_FETCH: {
      return { ...state, confirmSMSCodeFetch: action.payload };
    }

    case actions.SET_INPUT_WARNING: {
      return { ...state, inputWarning: action.payload };
    }

    case actions.SET_TIMER_START: {
      return { ...state, timerStartTime: action.payload };
    }

    case actions.SET_VIEW_RESEND_BUTTON: {
      return { ...state, isViewResendButton: action.payload };
    }

    case actions.SET_OTP_ID: {
      return { ...state, otpId: action.payload };
    }

    case actions.SET_FETCH_ERROR: {
      return { ...state, fetchError: action.payload };
    }

    case actions.SET_TELEPONY_TIMER_START: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          timerStartTime: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_VIEW_RESEND_BUTTON: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          isViewResendButton: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_VIEW_TRYOUT_BUTTON: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          isViewTryoutButton: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_VIEW_TIMEOUT_BUTTON: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          isViewTimeoutButton: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_TOTAL_RESEND_TRIES: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          totalResendTries: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_CURRENT_RESEND_TRIES: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          currentResendTries: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_SMS_CONFIRMED: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          isConfirmed: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_REQUEST_FETCHING: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          isFetching: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_AWAITING_STATE: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          awaitingState: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_WRONG_CODE_STATE: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          wrongCodeState: action.payload,
        },
      };
    }

    case actions.SET_TELEPONY_GLOBAL_TIMEOUT_STATE: {
      return {
        ...state,
        teleponyConfirm: {
          ...state.teleponyConfirm,
          globalTimeoutState: action.payload,
        },
      };
    }

    case actions.SET_RESET_SMS_VERIFICATION: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
}

export function requestConfirmCode(payload) {
  return {
    type: actions.REQUEST_CONFIRM_CODE,
    payload,
  };
}

export function sendConfirmCode(payload) {
  return {
    type: actions.SEND_CONFIRM_CODE,
    payload,
  };
}

export function setIsConfirmSMSCodeFetch(payload) {
  return {
    type: actions.SET_CONFIRM_SMS_CODE_FETCH,
    payload,
  };
}

export function setInputWarning(payload) {
  return {
    type: actions.SET_INPUT_WARNING,
    payload,
  };
}

export function setTimerStart(payload) {
  return {
    type: actions.SET_TIMER_START,
    payload,
  };
}

export function setViewResendButton(payload) {
  return {
    type: actions.SET_VIEW_RESEND_BUTTON,
    payload,
  };
}

export function setOtpId(payload) {
  return {
    type: actions.SET_OTP_ID,
    payload,
  };
}

export function setFetchError(payload) {
  return {
    type: actions.SET_FETCH_ERROR,
    payload,
  };
}

export function setTeleponyTimerStart(payload) {
  return {
    type: actions.SET_TELEPONY_TIMER_START,
    payload,
  };
}

export function setTeleponyViewResendButton(payload) {
  return {
    type: actions.SET_TELEPONY_VIEW_RESEND_BUTTON,
    payload,
  };
}

export function setTeleponyViewTryoutButton(payload) {
  return {
    type: actions.SET_TELEPONY_VIEW_TRYOUT_BUTTON,
    payload,
  };
}

export function setTeleponyViewTimeoutButton(payload) {
  return {
    type: actions.SET_TELEPONY_VIEW_TIMEOUT_BUTTON,
    payload,
  };
}

export function setTeleponyTotalResendTries(payload) {
  return {
    type: actions.SET_TELEPONY_TOTAL_RESEND_TRIES,
    payload,
  };
}

export function setTeleponyCurrentResendTries(payload) {
  return {
    type: actions.SET_TELEPONY_CURRENT_RESEND_TRIES,
    payload,
  };
}

export function setTeleponySMSConfirmed(payload) {
  return {
    type: actions.SET_TELEPONY_SMS_CONFIRMED,
    payload,
  };
}

export function setTeleponyRequestFetching(payload) {
  return {
    type: actions.SET_TELEPONY_REQUEST_FETCHING,
    payload,
  };
}

export function setTeleponyAwatingState(payload) {
  return {
    type: actions.SET_TELEPONY_AWAITING_STATE,
    payload,
  };
}

export function setTeleponyWrongCodeState(payload) {
  return {
    type: actions.SET_TELEPONY_WRONG_CODE_STATE,
    payload,
  };
}

export function setTeleponyGlobalTimeoutState(payload) {
  return {
    type: actions.SET_TELEPONY_GLOBAL_TIMEOUT_STATE,
    payload,
  };
}

export function resetSMSVerification() {
  return {
    type: actions.SET_RESET_SMS_VERIFICATION,
  };
}
